import React, { useState, useEffect } from 'react';
import { BarChart2, Phone, ShieldCheck, Bot, MessageSquare, Lock } from 'lucide-react';
import content from '../../translations/content.json';
import './style.css';

const iconComponents = {
  Volume2: BarChart2,
  PhoneCall: Phone,
  ShieldCheck: ShieldCheck,
  Bot: Bot,
  MessageSquare: MessageSquare,
  Lock: Lock,
};

const ImpactMetrics = () => {
  const haloColors = ["bg-purple-50", "bg-violet-50", "bg-pink-50", "bg-rose-50", "bg-orange-50", "bg-red-50"];
  const textColors = ["text-[#5E17EB]", "text-[#7C3AED]", "text-[#E11D48]", "text-[#EC4899]", "text-[#FF6B00]", "text-[#FF3D00]"];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const metricsPerPage = 5; // Increased to 5 to decrease individual card width

  useEffect(() => {
    let interval;
    if (!isPaused) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          (prevIndex + 1) % content.metrics.items.length
        );
      }, 3000);
    }

    return () => clearInterval(interval);
  }, [isPaused]);

  const displayedMetrics = [
    ...content.metrics.items,
    ...content.metrics.items,
  ];

  return (
    <section className="impact-metrics-section">
      <div className="impact-metrics-container">
        <div className="impact-metrics-subtitle-container">
          <span className="text-sm">⊹</span>
          <span>{content.metrics.subtitle}</span>
        </div>
        <div
          className="impact-metrics-carousel-wrapper"
          data-testid="impact-metrics-carousel-wrapper"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className="impact-metrics-carousel-track"
            data-testid="impact-metrics-carousel-track"
            style={{ transform: `translateX(-${currentIndex * (100 / metricsPerPage)}%)` }}
          >
            {displayedMetrics.map((item, index) => {
              const Icon = iconComponents[item.icon];
              return (
                <div
                  key={index}
                  className="impact-metric-card"
                  style={{ flex: `0 0 ${100 / metricsPerPage}%` }}
                  data-testid={`metric-card-${index}`}
                >
                  <div className={`impact-metric-icon-container ${haloColors[index % haloColors.length]}`}>
                    {Icon && <Icon className={`impact-metric-icon ${textColors[index % textColors.length]}`} strokeWidth="2.5" />}
                  </div>
                  <p className={`impact-metric-value ${textColors[index % textColors.length]}`}>{item.value}</p>
                  <p className="impact-metric-label">{item.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactMetrics;
